import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import CEAddToCartButton from './CEAddToCartButton.jsx';

const mountAddToCartButtons = () => {
  const elements = document.querySelectorAll('.add-to-cart-button-react');

  if (!elements.length) return;

  elements.forEach((element) => {
    if (!element || element.dataset.reactMounted === 'true') return;
    element.dataset.reactMounted = 'true';

    const storeName = element.getAttribute('data-store-name') || 'shared';
    const language = element.getAttribute('data-language') || 'fr';

    createRoot(element).render(
      <StrictMode>
        <CEAddToCartButton storeName={storeName} language={language} />
      </StrictMode>,
    );
  });
};

mountAddToCartButtons();
